import "./readable-form.scss";

/**
 * Body for a confirm modal, rendered inside the shared ModalComponents — replaces
 * window.confirm, which renders the browser's own chrome ("localhost:3000 says") and
 * looks nothing like the app.
 *
 * NOT for use inside another modal: Bootstrap does not support a modal within a modal.
 * Confirm inline there instead (see DevelopmentPlanModal).
 */
const ConfirmDialog = (props: any) => {
  const { message, detail, confirmLabel, onConfirm, onCancel } = props;

  return (
    <div className="confirm-dialog readable-form">
      <p className="confirm-message">{message}</p>
      {detail && <p className="confirm-detail">{detail}</p>}

      <div className="modal-btn-wrapper mt-4 mb-2">
        <div>
          <button type="button" className="btn cancel-btn buttonsize" onClick={onCancel}>
            Cancel
          </button>
        </div>
        <div>
          <button type="button" className="btn btn-danger buttonsize confirm-btn" onClick={onConfirm}>
            {confirmLabel || "Remove"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
